import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { style: {"padding":"20px","background-color":"#fff"} }
const _hoisted_3 = { class: "footer flex-ter-end" }

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { useRoute } from 'vue-router'
import { getCustomerShop } from '@/apis/order'
import { isJA, isD2C } from '@/store'
import { getAdtList } from '@/apis/addition'
import { getAdditionalLabel } from '@/apis/inShipping'
import { getDeli } from '@/util/calcAdt'
import { getShopLogistics } from '@/apis/setup'
import { useStore } from 'vuex'
interface ADDITION_PROPS {
  type: string;
  addition: any;
  noSpot: boolean;
  isGroup: boolean;
  noAdditionalFlag?: number;
  product?: any
}

export default /*#__PURE__*/_defineComponent({
  props: ['type', 'title'],
  emits: ['change'],
  setup(__props, { expose, emit: emits }) {

const props = __props
const route = useRoute()
// 附加项类型 AdtCfg 类目附加项 AdtOrder 商品附加项 DeliAdt 发货附加项
// isGroup 是否组合商品
const isGroup = ref(false)
// noSpot 不允许选择抽检
const noSpot = ref(false)


const order = '/oem/utility/Calculator'
// 附加项类型 AdtCfg 类目附加项 AdtOrder 商品附加项 DeliAdt 发货附加项
const type = ref('AdtOrder')
const title = ref('')
const data = ref([])
const additionList = ref([])
const visible = ref(false)
const createTypeVisible = ref(false)
const product = ref({})
const createType = ref(2)
const sendType = ref(2)
const deliveryAdditionalList: any = ref([])
const loading = ref(false)
// mustAdditionId 必选发货附加项
const mustAdditionId: any = ref([])
const noAdditionalFlag = ref(0)
const open = async (params: ADDITION_PROPS) => {
  mustAdditionId.value = []
  const { type: additionType, addition } = params
  noAdditionalFlag.value = params.noAdditionalFlag ?? 0
  isGroup.value = params.isGroup
  noSpot.value = params.noSpot
  type.value = additionType
  product.value = params.product ?? {}
  if (additionType === 'DeliAdt') {
    deliveryAdditionalList.value = addition
    if (deliveryAdditionalList.value.length === 0) {
      if (!isD2C()) {
        if (isJA()) {
          // 2b 弹窗选择配送地
          createTypeVisible.value = true
          return
        }
        sendType.value = 0
        await getDefaultDeliveryAddition2B()
      }
      if (isD2C()) {
        await getDefaultDeliveryAddition2C()
      }
    }
  }
  if (additionType === 'AdtOrder') {
    additionList.value = addition ?? []
  }
  visible.value = true
}
const handleAdt = (addition: any) => {
  emits('change', addition)
  visible.value = false
}
const isAmazon = ref()
const store = useStore()
watch(() => store.state.route.curShop, () => {
  if (store.state.route.curShop) {
    getCustomerShop().then((res: any) => {
      if (res.success) {
        isAmazon.value = res.data.customerShopPlatform === 4 && res.data.customerShopAuthStatus
      }
    })
  }
})
const chooseCall = async () => {
  if (isD2C()) {
    await getDefaultDeliveryAddition2C()
  } else {
    await getDefaultDeliveryAddition2B()
  }
  createTypeVisible.value = false
  visible.value = true
}

expose({
  open
})
const adtList = ref([])
const additionalLabelDict: any = ref({})
const getDefaultDeliveryAddition2B = async () => {
  loading.value = true
  const resData = await getAdtList({ productType: 1, source: 1 })
  // 获取发货附加险
  adtList.value = resData.data.deliveryAdditionList.map((e: any) => ({
    ...e,
    ingredientsCount: 1,
    ingredientsSku: ''
  }))
  const labelData = await getAdditionalLabel();
  (labelData.data || []).forEach((e: { dictKey: string | number; dictValue: any; }) => {
    additionalLabelDict.value[e.dictKey] = e.dictValue?.split(',')?.[0]
  })
  console.log('additionalLabelDict.value', additionalLabelDict.value)

  if (store.getters.isLogin) {
    // 获取默认附加项
    const defaultAddition = await getDeli()
    defaultAddition.forEach((v: any) => {
      if (!mustAdditionId.value.some((v2: any) => v2.additionCode === v.additionCode)) {
        mustAdditionId.value.push(v.additionCode)
        deliveryAdditionalList.value.push(v)
      }
    })
  }
  if (sendType.value !== 0) {
    // 除了其他
    const maskAddition = adtList.value.find((e: { additionCode: any; }) => String(e.additionCode) === additionalLabelDict.value.need_mark_delivery_addition_id)
    if (maskAddition && mustAdditionId.value.indexOf(additionalLabelDict.value.need_mark_delivery_addition_id) === -1) {
      mustAdditionId.value.push(additionalLabelDict.value.need_mark_delivery_addition_id)
      deliveryAdditionalList.value.push(maskAddition)
    }
    const labelAddition = adtList.value.find((e: { additionCode: any; }) => String(e.additionCode) === additionalLabelDict.value.need_label_delivery_addition_id)
    if (labelAddition && mustAdditionId.value.indexOf(additionalLabelDict.value.need_label_delivery_addition_id) === -1) {
      mustAdditionId.value.push(additionalLabelDict.value.need_label_delivery_addition_id)
      deliveryAdditionalList.value.push(labelAddition)
    }
  }
  if (!deliveryAdditionalList.value.find((v: any) => v.additionCode === 23)) {
    deliveryAdditionalList.value.push(adtList.value.find((v: any) => v.additionCode === 23))
  }
  loading.value = false
}
const getDefaultDeliveryAddition2C = async () => {
  const resData = await getAdtList({ productType: 1, source: 1 })
  // 获取发货附加险
  adtList.value = resData.data.deliveryAdditionList.map((e: any) => ({
    ...e,
    ingredientsCount: 1,
    ingredientsSku: ''
  }))
  if (!store.getters.isLogin) return
  const shopData: any = await getShopLogistics();
  (shopData.data.additionItemList ?? []).forEach((item: any) => {
    const n: any = adtList.value.find((i: any) => i.additionCode === item.additionCode)
    deliveryAdditionalList.value.push({
      ...n,
      ...item
    })
  })
  if (!deliveryAdditionalList.value.find((v: any) => v.additionCode === 42)) {
    deliveryAdditionalList.value.push(adtList.value.find((v: any) => v.additionCode === 42))
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              list: additionList.value,
              "onUpdate:list": _cache[0] || (_cache[0] = ($event: any) => ((additionList).value = $event)),
              onCommit: handleAdt,
              type: type.value,
              title: title.value,
              isGroup: isGroup.value,
              noSpot: true,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false)),
              mustAdditionId: mustAdditionId.value,
              cfg: deliveryAdditionalList.value,
              "onUpdate:cfg": _cache[2] || (_cache[2] = ($event: any) => ((deliveryAdditionalList).value = $event)),
              onSave: handleAdt,
              isCalculator: true,
              proxy: { ...product.value, noAdditionalFlag: noAdditionalFlag.value },
              hiddenWashSku: true
            }, null, 8, ["list", "type", "title", "isGroup", "mustAdditionId", "cfg", "proxy"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })),
    _createVNode(_component_el_dialog, {
      modelValue: createTypeVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createTypeVisible).value = $event)),
      "custom-class": "createTypeVisible",
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('配送')), 1),
        _createElementVNode("div", _hoisted_2, [
          (isAmazon.value)
            ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 0,
                modelValue: createType.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createType).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('通过FBA补货计划发货')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('普通发货')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (createType.value === 2)
            ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 1,
                modelValue: sendType.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sendType).value = $event)),
                style: {"padding":"10px 0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('乐天')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 3 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('SHOPLIST')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 4 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('ZOZOTOWN')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('其他')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (createTypeVisible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: chooseCall,
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})